import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import { retrieveFundings } from "./retrieve-fundings";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";
import type { FundingListItemVM } from "@shared-kernel/application/ports/admin/admin-repository";

const initialState: RetrievalState<PaginatedResult<FundingListItemVM>> = {
  fetching: "idle",
  data: {
    items: [],
    page: 1,
    pageSize: 50,
    total: 0,
    totalPages: 0,
  },
};

export const retrieveFundingsReducer = createReducer<RetrievalState<PaginatedResult<FundingListItemVM>>>(initialState, builder => {
  builder.addCase(retrieveFundings.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveFundings.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveFundings.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
